module.exports = __webpack_public_path__ + "img/header_tablette.a03ab3e3.jpg";